export class RestoreNeptuneRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "NeptuneRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreNeptuneRequest.attributeTypeMap;
    }
    constructor() {
    }
}
